import type { CheckHistoryPoint } from '@ops-monitor/shared';

const STROKE: Record<string, string> = {
  ok: 'var(--chip-up)',
  warn: '#fab219',
  crit: 'var(--chip-down)',
  nodata: 'var(--chip-unknown)',
};

/**
 * Single-series sparkline of check history. One series → no legend box (the
 * tile title names it); color follows the worst-recent status, values are in
 * `title` tooltips. Recessive baseline, 2px line, no axis chrome.
 */
export function Sparkline({ points }: { points: CheckHistoryPoint[] }) {
  const numeric = points.filter((p): p is CheckHistoryPoint & { value: number } => typeof p.value === 'number');
  if (numeric.length < 2) {
    return <div className="kpi__meta">история появится по мере накопления</div>;
  }
  const width = 240;
  const height = 64;
  const values = numeric.map((p) => p.value);
  const max = Math.max(...values);
  const min = Math.min(...values);
  const span = max - min || 1;
  const stepX = width / (numeric.length - 1);
  const path = numeric
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${(i * stepX).toFixed(1)},${(height - 4 - ((p.value - min) / span) * (height - 10)).toFixed(1)}`)
    .join(' ');
  const last = numeric.at(-1);

  return (
    <svg className="sparkline" viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" role="img" aria-label="История значения">
      <line x1="0" y1={height - 4} x2={width} y2={height - 4} stroke="var(--border)" strokeWidth="1" />
      <path d={path} fill="none" stroke={STROKE[last?.status ?? 'nodata']} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      {last ? (
        <circle
          cx={width}
          cy={height - 4 - ((last.value - min) / span) * (height - 10)}
          r="3"
          fill={STROKE[last.status]}
          stroke="var(--bg-surface)"
          strokeWidth="2"
        />
      ) : null}
    </svg>
  );
}
